import { useState } from 'react';

export const useModal = () => {
  const [open, setOpen] = useState(false);

  const toggleModal = () => setOpen((open) => !open);
  const closeModal = () => setOpen(false);
  const openModal = () => setOpen(true);

  return {
    open,
    openModal,
    closeModal,
    toggleModal,
  };
};
